module.exports = __webpack_public_path__ + "static/media/event3.f3be0125.jpg";